/* tslint:disable */
/* eslint-disable */
import { LocalizedTextDisplayModel as AceXFoundPortalCoreCaqModelsLocalizedTextDisplayModel } from '../../../../../../ace/xFound/Portal/Core/CAQ/Models/localized-text-display-model';
import { BaseModel } from '@/core/models/base.model';
import { FormGroup, FormControl, FormArray, AbstractControl, Validators } from '@angular/forms';

// All imports for FormGroups..
import { LocalizedTextDisplayModelFormGroup as AceXFoundPortalCoreCaqModelsLocalizedTextDisplayModelFormGroup } from '@/api/model-index';

export interface IFrageAuswahlOptionDisplayModel {
  id?: number;
  name?: null | Array<AceXFoundPortalCoreCaqModelsLocalizedTextDisplayModel>;
}
export class FrageAuswahlOptionDisplayModel extends BaseModel implements IFrageAuswahlOptionDisplayModel {
  id?: number;
  name?: null | Array<AceXFoundPortalCoreCaqModelsLocalizedTextDisplayModel>;
}
class BaseFrageAuswahlOptionDisplayModelFormGroup extends FormGroup {
  private static _instance: FrageAuswahlOptionDisplayModelFormGroup;
  
  public static get Instance(): FrageAuswahlOptionDisplayModelFormGroup {
    this._instance = new FrageAuswahlOptionDisplayModelFormGroup({
      id: new FormControl(null),
      name: new FormArray([]),
    });

    return this._instance;
  }
}


export class FrageAuswahlOptionDisplayModelFormGroup extends BaseFrageAuswahlOptionDisplayModelFormGroup {
  public get Id(): FormControl {
    return this.controls["id"] as FormControl;
  }
  public get Name(): FormArray<FormControl<null> | AceXFoundPortalCoreCaqModelsLocalizedTextDisplayModelFormGroup> {
    return this.controls["name"] as FormArray<FormControl<null> | AceXFoundPortalCoreCaqModelsLocalizedTextDisplayModelFormGroup>;
  }
  

}

export module FrageAuswahlOptionDisplayModelForm
  {
    export class FormFields
    {
      static _id: string = "id";
      static _name: string = "name";
    }
  }

